import { connect } from 'react-redux'
import * as selector from '../../state/manage/selector'
import * as action from '../../state/manage/action'
import ManageUser from './ManageUser'
import Globals from '../../../globals'
import { selectPartnerList, selectStoreList } from '../../../globals/state/selector'

const mapStateToProps = (state, props) => {
    return {
        currentUser: selector.selectCurrentUser(state),
        userList: selector.selectUserList(state),
        currentUserId: selector.selectCurrentUserId(state),
        salutationList: Globals.selector.selectSalutationList(state),
        partnerList: selectPartnerList(state),
        passwordStatus: selector.selectPasswordStatus(state),
        validationMessageList: selector.selectValidationMessageList(state),
        isUniqueConstraintViolation: selector.selectIsUniqueConstraintViolation(state),
        storeList: selectStoreList(state),
    }
}

const mapDispatchToProps = {
    findAllUser: action.findAllUser,
    changeCurrentUserId: action.changeCurrentUserId,
    changeUser: action.changeUser,
    toggleRole: action.toggleRole,
    toggleWidgetAccess: action.toggleWidgetAccess,
    createEmployee: action.createEmployee,
    generateNewPassword: action.generateNewPassword,
    createExternalUser: action.createExternalUser,
    changeExternalUser: action.changeExternalUser,
    saveUser: action.saveUser,
    createUser: action.createUser,
    findAllRole: action.findAllRole,
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageUser)



// WEBPACK FOOTER //
// ./src/modules/security/component/manage/ManageUserContainer.js